const Api = require('../services/api');
const apiURLBuilder = require('../core/apiURLBuilder');
const formActions = require('react-redux-form').actions;
const actionTypes = require('constants/actionTypes');

const saveCreditService = (dispatch, saveRequestData, callback) => {
    Api.post(apiURLBuilder.getURL('saveCredit'), saveRequestData).then(
        response => {
            const data = response.body;
            if (data.status === 'OK') {
                dispatch(formActions.change('userProfile.creditCard', data.creditCard));
                callback(true, {});
            } else {
                callback(false, data.errors);
            }
        },
        error => {
            callback(false, error);
        }
    );
};

const saveCredit = (data, accessToken, callback) => {
    return dispatch => {
        const saveRequestData = {
            header: {
                Authorization: 'Bearer ' + accessToken,
            },
            query: data,
        };

        saveCreditService(dispatch, saveRequestData, callback);
    };
};

const updateCreditService = (dispatch, cardConfigId, saveRequestData, callback) => {
    Api.post(apiURLBuilder.getURL('updateCreditId', { cardConfigId }), saveRequestData).then(
        response => {
            const data = response.body;
            if (data.status === 'OK') {
                callback(true, {});
            } else {
                callback(false, data.errors);
            }
        },
        error => {
            callback(false, error.body.errors);
        }
    );
};

const updateCredit = (cardConfigId, data, accessToken, callback) => {
    return dispatch => {
        const saveRequestData = {
            header: {
                Authorization: 'Bearer ' + accessToken,
            },
            query: data,
        };

        updateCreditService(dispatch, cardConfigId, saveRequestData, callback);
    };
};

const saveDebitService = (dispatch, saveRequestData, callback) => {
    Api.post(apiURLBuilder.getURL('saveDebit'), saveRequestData).then(
        response => {
            const data = response.body;
            if (data.status === 'OK') {
                dispatch(formActions.change('userProfile.debitCard', data.debitCard));
                callback(true, {});
            } else {
                callback(false, data.errors);
            }
        },
        error => {
            callback(false, error.body.errors);
        }
    );
};

const saveDebit = (data, accessToken, callback) => {
    return dispatch => {
        const saveRequestData = {
            header: {
                Authorization: 'Bearer ' + accessToken,
            },
            query: data,
        };

        saveDebitService(dispatch, saveRequestData, callback);
    };
};

const updateDebitService = (dispatch, cardConfigId, saveRequestData, callback) => {
    Api.post(
        apiURLBuilder.getURL('updateDebitId', { cardConfigId }),
        saveRequestData,
        'application/x-www-form-urlencoded',
        '*/*'
    ).then(
        response => {
            const data = response.body;
            if (data.status === 'OK') {
                callback(true, {});
            } else {
                callback(false, data.errors);
            }
        },
        error => {
            callback(false, error.body.errors);
        }
    );
};

const updateDebit = (cardConfigId, data, accessToken, callback) => {
    return dispatch => {
        const saveRequestData = {
            header: {
                Authorization: 'Bearer ' + accessToken,
            },
            query: data,
        };

        updateDebitService(dispatch, cardConfigId, saveRequestData, callback);
    };
};

const getOpenCreditPDFContract = (dispatch, accessToken) => {
    return Api.get(
        apiURLBuilder.getURL('pdfINE'),
        {
            header: {
                Authorization: 'Bearer ' + accessToken,
            },
        },
        'json',
        '*/*'
    )
        .then(response => {
            if (response.status === 200) {
                dispatch({
                    type: actionTypes.GET_INE_PDF,
                    data: response.text,
                });

                return response.text;
            }
        })
        .catch(e => {
            return e;
        });
};

const getOpenCreditPDF = accessToken => {
    return dispatch => {
        return getOpenCreditPDFContract(dispatch, accessToken);
    };
};

export default {
    saveCredit,
    updateCredit,
    saveDebit,
    updateDebit,
    getOpenCreditPDF,
};
